module.exports = __webpack_public_path__ + "img/pop_1.0c510cb6.svg";